import classNames from 'classnames'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { Divider } from 'primereact/divider'
import { InputText } from 'primereact/inputtext'
import { Menu } from 'primereact/menu'
import { Toast } from 'primereact/toast'
import { React, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { httpcodeIsOK, showToastError, showToastSuccess } from '../../lib/helpers'
import { BASE_MEDIA_QUERY, tooltipOptions } from '../../static/config'
import { Messages } from '../../static/messages'
import { authActions } from '../../store/auth'
import { uiActions } from '../../store/ui'
import classes from '../../assets/scss/Layout.module.scss'
import api from '../../lib/api'

const Topbar = () => {
  const { sidenavOpened } = useSelector((state) => state.ui)
  const dispatch = useDispatch()
  const menu = useRef(null)
  const toast = useRef(null)
  const history = useHistory()
  const emailInput = useRef()
  const newPasswordInput = useRef()
  const oldPasswordInput = useRef()
  const passwordRepeatedInput = useRef()
  const [loading, setLoading] = useState(false)
  const [passwordDialog, setPasswordDialog] = useState(false)

  const items = [
    {
      label: 'Password',
      icon: 'pi pi-lock',
      command: () => {
        setPasswordDialog(true)
      }
    },
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => {
        dispatch(authActions.logout())
        history.replace('/')
      }
    }
  ]

  const toggleSidenavHandler = () => {
    dispatch(uiActions.toggleSidenav(!sidenavOpened))
  }

  const topbarClassName = classNames(classes.topbar)

  const changePassword = async (event) => {
    event.preventDefault()
    setLoading(true)
    const enteredOldPassword = oldPasswordInput.current.value
    const enteredNewPassword = newPasswordInput.current.value
    const enteredRepPassword = passwordRepeatedInput.current.value

    if (enteredNewPassword !== enteredRepPassword) {
      showToastError(toast, 'Le password inserite non coincidono!')
    } else {
      try {
        const res = await api.changePassword({
          email: emailInput.current.value,
          old_password: enteredOldPassword,
          new_password: enteredNewPassword
        })
        if (httpcodeIsOK(res.status)) {
          showToastSuccess(toast, 'Password aggiornata correttamente!')
          setPasswordDialog(false)
        } else {
          showToastError(toast, res.data)
        }
      } catch (error) {
        if (error.response.data.status === 400) {
          showToastError(toast, 'Credenziali non valide!')
        } else {
          showToastError(toast, error)
        }
      }
    }
    setLoading(false)
  }

  return (
    <>
      <Toast ref={toast} />
      <Dialog
        position="middle"
        header="Cambia password"
        visible={passwordDialog}
        dismissableMask
        onHide={() => setPasswordDialog(false)}
        className=""
      >
        <form onSubmit={changePassword}>
          <p>Completa i seguenti campi per cambiare la tua password</p>
          <Divider />
          <div className="p-grid p-d-flex p-ai-center p-jc-center">
            <div className="p-col-12 p-sm-8">
              <div className="p-inputgroup p-mb-2">
                <span className="p-inputgroup-addon">
                  <i className="pi pi-user"></i>
                </span>
                <InputText
                  type="email"
                  id="email"
                  ref={emailInput}
                  placeholder="Indirizzo email"
                  required
                />
              </div>
              <div className="p-inputgroup p-mb-2">
                <span className="p-inputgroup-addon">
                  <i className="pi pi-key"></i>
                </span>
                <InputText
                  type="password"
                  id="oldPassword"
                  ref={oldPasswordInput}
                  placeholder="Password corrente"
                  required
                />
              </div>
              <div className="p-inputgroup p-mb-2">
                <span className="p-inputgroup-addon">
                  <i className="pi pi-key"></i>
                </span>
                <InputText
                  type="password"
                  id="newPassword"
                  ref={newPasswordInput}
                  placeholder="Nuova password"
                  required
                />
              </div>
              <div className="p-inputgroup p-mb-2">
                <span className="p-inputgroup-addon">
                  <i className="pi pi-key"></i>
                </span>
                <InputText
                  type="password"
                  id="repeatedPassword"
                  ref={passwordRepeatedInput}
                  placeholder="Ripeti password"
                  required
                />
              </div>
            </div>
          </div>
          <Divider />
          <div className="p-d-flex p-ai-center p-jc-center">
            <Button
              loading={loading}
              className="p-button-raised"
              label="INVIA"
            />
          </div>
        </form>
      </Dialog>
      <div
        className={`p-d-flex p-ai-center p-jc-between ${topbarClassName} p-shadow-1`}
        style={{ left: sidenavOpened && BASE_MEDIA_QUERY.matches ? '200px' : 0 }}
      >
        <div>
          <Button
            onClick={toggleSidenavHandler}
            tooltip={Messages.Tooltip.ButtonOpenCloseMenu}
            tooltipOptions={tooltipOptions}
            className="p-button-text white"
            icon="pi pi-bars"
          />
        </div>
        <div>&nbsp;</div>
        <div>
          <Menu model={items} popup ref={menu} id="popup_menu" />
          <Button
            onClick={(event) => menu.current.toggle(event)}
            aria-controls="popup_menu"
            aria-haspopup
            className="p-button-text white"
            icon="pi pi-cog"
          />
        </div>
      </div>
    </>
  )
}

export default Topbar
